import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { useContent } from '../../content/load';

const Wrap = styled.footer`
  margin-top: ${(p) => p.theme.step[10]}px;
  border-top: 1px solid ${(p) => p.theme.color.border.faint};
  background: ${(p) => p.theme.color.bg[1]};
  padding: ${(p) => p.theme.step[8]}px ${(p) => p.theme.layout.gutter}px;
`;

const Inner = styled.div`
  max-width: ${(p) => p.theme.layout.maxw}px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.5fr repeat(auto-fit, minmax(160px, 1fr));
  gap: ${(p) => p.theme.step[7]}px;
`;

const Brand = styled.div`
  max-width: 320px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Name = styled.div`
  font-size: ${(p) => p.theme.step[5]}px;
  font-weight: 700;
  letter-spacing: 0.02em;
`;

const Offices = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[0]}px;
  letter-spacing: 0.08em;
  color: ${(p) => p.theme.color.text[2]};
`;

const Contact = styled.a`
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[1]}px;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme.color.text[1]};
  text-decoration: none;

  &:hover {
    color: ${(p) => p.theme.color.accent.amber};
  }
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const ChipDot = styled.span`
  font-family: ${(p) => p.theme.font.mono};
  font-size: ${(p) => p.theme.step[0]}px;
  padding: 3px 8px;
  border: 1px solid ${(p) => p.theme.color.border.med};
  border-radius: 4px;
  color: ${(p) => p.theme.color.text[2]};
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Heading = styled.div`
  font-size: ${(p) => p.theme.step[0]}px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${(p) => p.theme.color.text[3]};
  margin-bottom: 4px;
`;

const FooterLink = styled(Link)`
  font-size: ${(p) => p.theme.step[3]}px;
  color: ${(p) => p.theme.color.text[1]};

  &:hover {
    color: ${(p) => p.theme.color.text[0]};
  }
`;

const Bottom = styled.div`
  max-width: ${(p) => p.theme.layout.maxw}px;
  margin: ${(p) => p.theme.step[7]}px auto 0;
  padding-top: ${(p) => p.theme.step[5]}px;
  border-top: 1px solid ${(p) => p.theme.color.border.faint};
  font-size: ${(p) => p.theme.step[1]}px;
  color: ${(p) => p.theme.color.text[3]};
`;

export function Footer() {
  const { site } = useContent();
  return (
    <Wrap>
      <Inner>
        <Brand>
          <Name>{site.brand.name}</Name>
          <Offices>
            {site.brand.offices.map((o) => (
              <span key={o}>{o}</span>
            ))}
          </Offices>
          {site.brand.email && (
            <Contact href={`mailto:${site.brand.email}`}>{site.brand.email}</Contact>
          )}
          <Chips>
            {site.compliance.chips.map((c) => (
              <ChipDot key={c}>{c}</ChipDot>
            ))}
          </Chips>
        </Brand>
        {site.footer.columns.map((col) => (
          <Column key={col.heading}>
            <Heading>{col.heading}</Heading>
            {col.links.map((l) => (
              <FooterLink key={l.href + l.label} to={l.href}>
                {l.label}
              </FooterLink>
            ))}
          </Column>
        ))}
      </Inner>
      <Bottom>
        © {new Date().getFullYear()} {site.brand.legalName}. {site.compliance.disclaimer}
      </Bottom>
    </Wrap>
  );
}
